module.exports = __webpack_public_path__ + "static/media/ic_buy_crypto.65211883.png";